export const environment = {
	name: "dev",
	production: false,
	apiUrl: "https://api-dev.whatsauto.com.br",
	brokerOfficialWSUrl: "https://brokerdev-ws.whatsauto.com.br",
	brokerOfficialQueueConsumerUrl: "",
	chatFlowAppAddress: "https://dev-chatflow.whatsauto.com.br",
	CDN_URL: "https://dev-cdn.whatsauto.com.br/files",
	audioConverterUrl: "https://audioconv.whatsauto.com.br/convert",
	sizeLimitWhenSavingCatalog: 10485760,
	showAutomatedResponseFlag: true,

	facebook: {
		appId: "1370185477731954",
		apiVersion: "v22.0",
		whatsAppConfigId: "940324608270320",
	},

	// These will be dynamically loaded based on the current hostname
	whatsAutoConfig: {
		appName: "WhatsAuto",
		favicon: "assets/whatsauto/favicon.ico",
		stylePath: "assets/themes/whatsauto.css",
		brand: "whatsauto",
	},
	whatsPartsConfig: {
		appName: "WhatsParts",
		favicon: "assets/whatsparts/favicon.ico",
		stylePath: "assets/themes/whatsparts.css",
		brand: "whatsparts",
	},
};
